import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mFooter",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "mFooter-main"
  }, [_c('div', {
    staticClass: "logo btn",
    style: {
      background: `url(${require('@images/ui/logo.png')}) center/auto 100% no-repeat`
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/');
      }
    }
  }), _c('div', {
    staticClass: "shares"
  }, [_c('div', {
    staticClass: "shares-item",
    class: _vm.isMobile && 'wap',
    on: {
      "click": function ($event) {
        return _vm.onShare('telegram');
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "telegram"
    }
  })], 1), _c('div', {
    staticClass: "shares-item",
    on: {
      "click": function ($event) {
        return _vm.onShare('twitter');
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };